const _v = '6.5.0' // VERSÃO DO SISTEMA
const localAisp = '_POLICE_SESSION_AISP_'
import cli from '../data/cliente'

import $ptBR from '../traducao/pt-br.js'
import $enEN from '../traducao/en-en.js'
import $esES from '../traducao/es-es.js'

import flSimNao from '../modules/components/simNao/main.vue'
import flNovoOuEditar from '../modules/components/novoOuEditar/main.vue'
import flCarregando from '../modules/components/carregando/main.vue'
import fltableFooter from '../modules/components/rodape-tabela/main.vue'
import flMarcaDgua from '../modules/components/marca-dgua/main.vue'
import flGeradoPor from '../modules/components/gerado-por/main.vue'
import flCabecalho from '../modules/components/cabecalho/main.vue'
import flCabecalhoBrasao from '../modules/components/cabecalho/cabecalho-brasao.vue'
import flCabecalhoForm from '../modules/components/cabecalho-form/main.vue'
import flModalErro from '../modules/components/modal-erro/main.vue'
import flCabecalhoMapa from '../modules/components/cabecalho-mapa/main.vue'
import modal from '../modules/components/modal/main.vue'
import modalAjuda from '../modules/components/modal-ajuda/main.vue'
import flChat from '../modules/components/mensagem/main.vue'
import flChatAjuda from '../modules/components/mensagem-ajuda/main.vue'
import { VueEditor } from 'vue2-editor'
import flSelect from '../modules/components/finder-select/main.vue'
import flDateTime from '../modules/components/datetime/main.vue'
import flTrecho from '../modules/components/trecho/main.vue'
import flPassageiro from '../modules/components/passageiro/main.vue'
import flCargaTransportada from '@/modules/components/carga-transportada/main.vue'
import Spinner from '@/modules/components/spinner/main.vue';
import flCalendario from '../modules/components/calendario/main.vue'
import flPesquisa from '../modules/components/pesquisar/main.vue'
import flCampoBusca from '../modules/components/pesquisar/campo-busca.vue'
import flCampoBuscaTabela from '../modules/components/pesquisar/campoBuscaTabela.vue'
import flOrgaosApoiados from '../modules/layout/admin-geral/orgaos-apoiados/main.vue'
import flCabecalhoFixo from '../modules/components/cabecalho/fixo.vue'
import flAtividades from '../modules/components/atividade/main.vue'
import flLocalMissao from '../modules/components/local-missao/main.vue'
import flLogCliente from '../modules/components/log-usuario/main.vue'
import flNaturezaTipo from '../modules/components/natureza-tipo/main.vue'
import flModalConfirmar from '../modules/components/modal-confirmar/main.vue'
import flModalReativar from '../modules/components/modal-reativar/main.vue'
import flModalDesativar from '../modules/components/modal-desativar/main.vue'
import flModalExcluir from '../modules/components/modal-excluir/main.vue'
import flNotificacoes from '../modules/components/notificacoes/main.vue'
import flOrgaos from '../modules/components/orgao/main.vue'
import flPrivilegios from '../modules/components/privilegio/main.vue'
import flQrCode from '../modules/components/qr-code-app/main.vue'
import flSelectEstado from '../modules/components/select-estado/main.vue'
import flSelectTraducao from '../modules/components/select-traducao-login/main.vue'
import flSelectTraducaoMenu from '../modules/components/select-traducao-menu/main.vue'
import flUploadFile from '../modules/components/upload-file/main.vue'
import flVisualizacaoAssinatura from '../modules/components/validacao-assinatura-documento/main.vue'
import flVisualizacaoAssinatura2 from '../modules/components/validacao-assinatura-documento/main2.vue'
import flVisualizarDiario from '../modules/components/visualizar-diario/main.vue'
import flLoad from '../modules/components/load/main.vue'
import flFiltroPorDatas from '../modules/components/filtro-por-datas/main.vue'
import flModalAssinatura from '../modules/components/modal-assinatura/main.vue'
import ModalAssinaturaEletronica from '../modules/components/modal-assinatura-eletronica/main.vue'
import flDiarioDeBordoDEFAULT from '../modules/layout/diario-de-bordo-piloto/default/cadastro/main.vue'
import flDiarioDeBordoPMES from '../modules/layout/diario-de-bordo-piloto/pm-es/cadastro/main.vue'
import flDiarioDeBordoMARANHAO from '../modules/layout/diario-de-bordo-piloto/maranhao/cadastro/main.vue'
import flDiarioDeBordoMGSIGA from '../modules/layout/diario-de-bordo-piloto/mg-siga/cadastro/main.vue'
import flRangeInput from '../modules/components/range-input/main.vue'
import QrcodeVue from 'qrcode.vue'
import flSelectAno from '../modules/components/select/select-ano.vue'
import flSelectSemanasAno from '../modules/components/select/select-semanas-ano.vue'
import flSelectMalhaSemanas from '../modules/components/select/select-malha-semanas.vue'
import CabecalhoModelo from '@/modules/components/cabecalho-modelo/main.vue'
import ModalSucesso from '@/modules/components/modal-sucesso/main.vue'
import CrudTemplate from '@/modules/components/tabela/crud-template.vue'
import TabelaTemplate from '@/modules/components/tabela/tabela.vue'
import FormTemplate from '@/modules/components/templates/form.vue'
import AnexoTemplate from '@/modules/components/templates/anexo.vue'
import InputSelect from '@/modules/components/inputs/select.vue'
import InputText from '@/modules/components/inputs/text.vue'
import InputData from '@/modules/components/inputs/input-data.vue'
import InputDataHora from '@/modules/components/inputs/input-data-hora.vue'
import InputTime from '@/modules/components/inputs/input-time.vue'
import InputTextarea from '@/modules/components/inputs/textarea.vue'
import InputTextMask from '@/modules/components/inputs/text-mask.vue'
import InputDecimal from '@/modules/components/inputs/decimal.vue'
import InputSearch from '@/modules/components/inputs/input-search.vue'
import InputModelSelect from '@/modules/components/inputs-model/select.vue'
import InputModelText from '@/modules/components/inputs-model/text.vue'
import InputModelData from '@/modules/components/inputs-model/input-data.vue'
import InputModelDataHora from '@/modules/components/inputs-model/input-data-hora.vue'
import InputModelTextarea from '@/modules/components/inputs-model/textarea.vue'
import InputModelTextMask from '@/modules/components/inputs-model/text-mask.vue'
import InputModelDecimal from '@/modules/components/inputs-model/decimal.vue'
import flModeloForm from '../modules/components/modelo-formulario/ModeloForm.vue'
import flHorarioUtc from '../modules/components/horario-utc/horarioUTC.vue'
import SelectItems from '@/modules/components/select-items/main.vue'
import Paginacao from '@/modules/components/paginacao/main.vue'
import TabsPadrao from '../modules/components/tabs/tabs.vue'

let accents = require('remove-accents')

var flDiarioDeBordo = flDiarioDeBordoDEFAULT

if (cli.get('diario_bordo_default') == '0') {
	flDiarioDeBordo = flDiarioDeBordoMGSIGA
}

if (cli.get('id') == 9) {
	flDiarioDeBordo = flDiarioDeBordoMGSIGA
}

if (cli.get('id') == 10) {
	flDiarioDeBordo = flDiarioDeBordoMARANHAO
}

if (cli.get('id') == 18) {
	flDiarioDeBordo = flDiarioDeBordoPMES
}

import ComponentsMixin from '../modules/componentsv2/ComponentsMixin.js'

export default {
	mixins: [ComponentsMixin],
	components: {
		AnexoTemplate,
		FormTemplate,
		TabelaTemplate,
		InputDecimal,
		InputSelect,
		InputText,
		InputData,
		InputDataHora,
		InputTime,
		InputTextarea,
		InputTextMask,
		InputSearch,
		InputModelSelect,
		InputModelText,
		InputModelData,
		InputModelDataHora,
		InputModelTextarea,
		InputModelTextMask,
		InputModelDecimal,
		CrudTemplate,
		ModalSucesso,
		CabecalhoModelo,
		flSimNao,
		flNovoOuEditar,
		flLoad,
		flCarregando,
		flCabecalho,
		flCabecalhoForm,
		flCabecalhoBrasao,
		fltableFooter,
		flModalErro,
		flMarcaDgua,
		flGeradoPor,
		flDiarioDeBordo,
		modal,
		modalAjuda,
		flDateTime,
		flTrecho,
		flCargaTransportada,
		Spinner,
		VueEditor,
		flCampoBusca,
		flCalendario,
		flPesquisa,
		flCabecalhoFixo,
		flAtividades,
		flCabecalhoMapa,
		flSelect,
		flLocalMissao,
		flLogCliente,
		flChat,
		flChatAjuda,
		flModalExcluir,
		flModalConfirmar,
		flModalReativar,
		flModalDesativar,
		flNaturezaTipo,
		flNotificacoes,
		flOrgaos,
		flPrivilegios,
		flQrCode,
		flSelectEstado,
		flSelectTraducao,
		flSelectTraducaoMenu,
		flUploadFile,
		flVisualizacaoAssinatura,
		flVisualizacaoAssinatura2,
		flVisualizarDiario,
		flModalAssinatura,
		ModalAssinaturaEletronica,
		flFiltroPorDatas,
		flRangeInput,
		QrcodeVue,
		flSelectAno,
		flSelectSemanasAno,
		flSelectMalhaSemanas,
		flCampoBuscaTabela,
		flPassageiro,
		flOrgaosApoiados,
		flModeloForm,
		flHorarioUtc,
		SelectItems,
		Paginacao,
		TabsPadrao,
	},

	mounted() {

		window.addEventListener('offline', (e) => {
			if (!navigator.onLine) {
				location.reload();
			}
		});

		window.addEventListener('online', (e) => {
			if (navigator.onLine) {
				location.reload();
			}
		});
	},

	computed: {
		_googleKey() {
			return 'AIzaSyDQ-IezUFxYkJGkmmvlBmv_gP99tdus--s'
		},

		_geraPDF() {
			return $cliente.get('assina_pdf') == '1' ? true : false
			//return true
			//return false
		},

		_getLangDp() {
			var t = this._getLang().split('-')[0]
			return t
		},

		_ambiente() {
			if (_.isNil($cliente.get('ambiente'))) {
				return 'TESTE'
			}
			return $cliente.get('ambiente').toUpperCase()
		},

		_isMobile() {
			var check = false
			var a = navigator.userAgent || navigator.vendor || window.opera
			if (
				/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
					a
				) ||
				/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
					a.substr(0, 4)
				)
			) {
				check = true
			}

			return check
		},

		_dev() {
			return $sessao.getDev()
		},

		_idUsuario() {
			return $sessao.getId()
		},

		_copy(obj) {
			return JSON.parse(JSON.stringify(obj))
		},

		_login() {
			return $sessao.getLogin()
		},

		_exibeOrgaoOperador() {
			return $cliente.get('id_orgao_operador_padrao') == '1' ? false : true
		},

		_now() {
			return new moment()
		},

		_nomeUsuario() {
			return $sessao.getNome()
		},

		_getDataFormat() {
			return $sessao.getDateFormat()
		},

		_getLangCpUpload() {

			if (this._getLangDp == 'pt') {
				return 'pt-br'
			}

			if (this._getLangDp == 'es') {
				return 'es-MX'
			}

			if (this._getLangDp == 'en') {
				return 'en'
			}
		},

		_foto() {
			if ($sessao.getFoto() != '') {
				return (
					this.getURL_WS('/foto/').replace('public/', '') + $sessao.getFoto()
				)
			}

			return ''
		},

		_urlServices() {
			return $cliente.get('ws_services')
		},

		_keyServices() {
			return $cliente.get('ws_services_key')
		},

		_unitsOld() {
			return [
				'FH',
				'M',
				'HC',
				'SC',
				'P',
				// 'OPH',
				// 'ED',
				// 'BFF',
				// 'ALF',
				// 'INF',
				'D',
				// 'TA',
				// 'OPC',
				'TC',
				'C(NG)',
				'C(NF)'
				// 'C',
				// 'P',
				// 'L',
			]
		},

		_colorsManutencao() {
			return {
				bks: [
					'#F0F0F0', //sem
					'#E8F5E9', //verde
					'#FFE0B2', //laranja
					'#FFCDD2', //vermelho
					'#FFCDD2', //preto
					'#E3F2FD', // azul
					'#F0F0F0', //sem
				],

				borders: [
					'#C0C0C0', //sem
					'#4CAF50', //verde
					'#FF9800', //laranja
					'#F44336', //vermelho
					'#F44336', //preto
					'#2196F3', // azul
					'#333', //preto
				],

				colors: [
					'#364156', //sem
					'#4CAF50', //verde
					'#EF6C00', //laranja
					'#F44336', //vermelho
					'#F44336', //preto
					'#0D47A1', // azul
					'#000', //preto
				],
			}
		},
	},

	methods: {
		getToken() {
			return $sessao.getToken()
		},

		getURL_WS(uri) {
			if (typeof uri === 'undefined') {
				return $config.get('WS')
			} else {
				if (uri.substring(0, 1) == '/') {
					return $config.get('WS') + uri
				} else {
					return $config.get('WS') + '/' + uri
				}
			}
		},

		getURL_SERVICES(uri) {
			if (typeof uri === 'undefined') {
				return this._urlServices
			} else {
				if (uri.substring(0, 1) == '/') {
					return this._urlServices + uri
				} else {
					return this._urlServices + '/' + uri
				}
			}
		},

		_units(motor = false) {
			if (motor) {
				return [
					'FH',
					'D',
					'M',
					'C(N1)',
					'C(N2)',
          			'C(NP)'
				]
			}
			return [
				'FH',
				'D',
				'M',
				'HC',
				'SC',
				'TC',
				'P',
			]
		},

		_unitsAll() {
			return [
				'FH',
				'HC',
				'SC',
				'TC',
				'C(N1)',
				'C(N2)',
				'C(NP)',
				'P',
			]
		},

		_fs(idModelo) {
			if (_.isNil(idModelo)) {
				idModelo = 0
			}

			// caso o id do modulo for 0, quer dizer que não é conhecido o modelo, com isso retorna todos os fs

			let list = []

			// arial 1D1
			if (idModelo == 3 || idModelo == 0) {
				list = list.concat(['CSN1', 'CSN2', 'DAY_WITHOUT_USE', 'TSN', 'TSO'])
			}

			// b2
			if (idModelo == 4 || idModelo == 0) {
				list = list.concat(['TSM', 'TSI'])
			}

			return list
		},

		_downloadKML(
			titulo,
			descricao,
			popTitulo,
			popDescricao,
			nomeArquivo,
			posicoes
		) {
			let string = `<?xml version="1.0" encoding="UTF-8"?><kml xmlns="http://www.opengis.net/kml/2.2">
				<Document>
					<name>{{titulo}}</name>
					<description>{{descricao}}
					</description>
					<Style id="yellowLineGreenPoly">
						<LineStyle>
							<color>7f00ffff</color>
							<width>4</width>
						</LineStyle>
						<PolyStyle>
							<color>7f00ff00</color>
						</PolyStyle>
					</Style>
					<Placemark>
					<name>{{popTitulo}}</name>
					<description>{{popDescricao}}</description>
					<styleUrl>#yellowLineGreenPoly</styleUrl>
					<LineString>
					<extrude>1</extrude>
					<tessellate>1</tessellate>
					<altitudeMode>absolute</altitudeMode>
					<coordinates>`

			string = string.replace('{{titulo}}', titulo)
			string = string.replace('{{descricao}}', descricao)

			string = string.replace('{{popTitulo}}', popTitulo)
			string = string.replace('{{popDescricao}}', popDescricao)

			for (var i in posicoes) {
				string +=
					posicoes[i].lng +
					',' +
					posicoes[i].lat +
					',' +
					posicoes[i].altitude +
					' '
			}

			string += `</coordinates>
				</LineString> </Placemark>
				</Document> </kml>`

			var element = document.createElement('a')
			element.setAttribute(
				'href',
				'data:text/plain;charset=utf-8,' + encodeURIComponent(string)
			)
			element.setAttribute('download', nomeArquivo + '.kml')

			element.style.display = 'none'
			document.body.appendChild(element)

			element.click()

			document.body.removeChild(element)
		},

		_unit(idModelo) {
			// arial 1D1
			if (idModelo == 3) {
				return ['BFF', 'BEF', 'ALF', 'D', 'FH', 'M', 'C']
			}

			// b2
			if (idModelo == 4) {
				return ['SC', 'FH', 'OPC', 'OPH', 'HC', 'ED', 'TC', 'ALF', 'BFF', 'TA']
			}
		},

		_cicloN1() {
			return new Promise((resolve, reject) => {
				this._axios(`/Parametro/get/127`, 'get', {
					callback: ({ _request, _status, parametro }) => {
						if (_request && _status) {
							resolve(parametro.valor || '')
						} else {
							reject('')
						}
					}
				})
			})
		},
		_cicloN2() {
			return new Promise((resolve, reject) => {
				this._axios(`/Parametro/get/128`, 'get', {
					callback: ({ _request, _status, parametro }) => {
						if (_request && _status) {
							resolve(parametro.valor || '')
						} else {
							reject('')
						}
					}
				})
			})
		},
		_cicloNP() {
			return new Promise((resolve, reject) => {
				this._axios(`/Parametro/get/129`, 'get', {
					callback: ({ _request, _status, parametro }) => {
						if (_request && _status) {
							resolve(parametro.valor || '')
						} else {
							reject('')
						}
					}
				})
			})
		},

		_fusoHorarioAeronave(idAeronave) {
			this._httpGet('/Aeronave/get_by_id/' + idAeronave, function (retorno) {
				if (retorno._request) {
					var aeronave = retorno.aeronave

					if(aeronave != null){
							if(aeronave.fuso_horario == null){
								return ''
							}
							const offset = moment.tz(aeronave.fuso_horario).format('Z');
							return offset
					}
					
				}
			})		
		},

		getAISP(callback) {
			if (sessionStorage.getItem(localAisp) != null) {
				callback(JSON.parse(sessionStorage.getItem(localAisp)))
			} else {
				$.getJSON(
					'clientes' + '/' + $cliente.get('nome_pasta') + '/aisp.json',
					function ($aisp) {
						localStorage.setItem(localAisp, $aisp)
						callback($aisp)
					}
				)
			}
		},

		_existe(item) {
			if (item == '' || item == null || _.isNil(item)) {
				return false
			}

			return true
		},

		_verificaDiarioAeronave(callback, idAero) {
			this._httpGet('Aeronave/verifica_diario/' + idAero, (response) => {
				callback(response)
			})
		},

		_decimalToHora(value) {
			if (_.isNil(value)) {
				return '0'
			}

			return value + ''.replace('.', ':')
		},

		_escondeMobile() {
			return window.innerWidth < 1024 ? false : true
		},

		_removerAcentos(palavra) {
			return accents.remove(palavra || '').toLowerCase()
		},

		_validaTempoMenor(tempo1, tempo2) {
			var hora1 = tempo1.split(':')
			var hora2 = tempo2.split(':')

			var d = new Date()
			var data1 = new Date(
				d.getFullYear(),
				d.getMonth(),
				d.getDate(),
				hora1[0],
				hora1[1]
			)
			var data2 = new Date(
				d.getFullYear(),
				d.getMonth(),
				d.getDate(),
				hora2[0],
				hora2[1]
			)

			return data2 > data1
		},

		_getHorimetro(callback, idAero) {
			this._httpGet('Aeronave/get_horimetro/' + idAero, function (response) {
				if (response._request) {
					callback(response)
				} else {
					callback(false)
				}
			})
		},

		_isInspection(item) {
			return (
				item.maintenance_mode != 'SLL' &&
				item.maintenance_mode != 'BFF' &&
				item.maintenance_mode != 'ALF' &&
				item.maintenance_mode != 'TA' &&
				item.maintenance_mode != 'OTL'
			)
		},

		_fusoHorarioAeronave(fuso) {
			if(fuso == '' || fuso == null){
				fuso = $cliente.get('fuso_horario')
			}
			return moment.tz(fuso).format('Z');
		},

		_exibeCargaManutencao(item, tipo) {
			if (
				// item.inspecao.maintenance_mode == 'TBO' ||
				// item.inspecao.maintenance_mode == 'SLL' ||
				item.maintenance_mode == 'BFF' ||
				item.maintenance_mode == 'ALF' ||
				item.maintenance_mode == 'TA'
				// item.inspecao.maintenance_mode == 'OTL'
			) {
				return false
			}

			return item.carga_manutencao_manual == '1'
		},

		_isEmail(email) {
			var er = /^[a-zA-Z0-9][a-zA-Z0-9\._-]+@([a-zA-Z0-9\._-]+\.)[a-zA-Z-0-9]{2}/

			if (er.exec(email)) {
				return true
			} else {
				return false
			}
		},

		_getVersao() {
			return _v
		},

		_getLang() {
			var lg = JSON.parse(localStorage.getItem('__POLICE_SESSION_LG_'))
			return lg['lg']
		},

		_setaLg(lg) {
			var ll = {}

			if (lg == 'pt-br') {
				ll = {
					lg: 'pt-br',
					decimal: ',',
					milhar: '.',
					sifrao: 'R$',
					dt: 'DD/MM/YYYY',
					utc: this._fusoHorario,
				}
			}

			if (lg == 'en-en') {
				ll = {
					lg: 'en-en',
					decimal: '.',
					milhar: ',',
					sifrao: '$',
					dt: 'MM/DD/YYYY',
				}
			}

			if (lg == 'es-py') {
				ll = {
					lg: 'es-py',
					decimal: '.',
					milhar: ',',
					sifrao: '₲',
					dt: 'DD/MM/YYYY',
				}
			}
			this._axios('Servico/set_idioma/' + lg, 'get', {
				finally: () => {
					localStorage.setItem('__POLICE_SESSION_LG_', JSON.stringify(ll))
					location.reload()
				}
			})
		},

		_traducao(local, texto) {
			switch ($sessao.getLang()) {
				case 'pt-br':
					return $ptBR[local][texto] + ''
					break
				case 'en-en':
					return $enEN[local][texto] + ''
					break
				case 'es-py':
					return $esES[local][texto] + ''
					break
			}
		},

		_converteTextoTempo(texto) {
			if (_.isNil(texto)) {
				return ''
			}

			var conversao = [
				{
					chave: '{{H}}',
					valor: 'hora',
				},
				{
					chave: '{{D}}',
					valor: 'dia',
				},
				{
					chave: '{{M}}',
					valor: 'mes',
				},
				{
					chave: '{{A}}',
					valor: 'ano',
				},
				{
					chave: '{{C}}',
					valor: 'ciclo',
				},
				{
					chave: '{{HS}}',
					valor: 'horas',
				},
				{
					chave: '{{DS}}',
					valor: 'dias',
				},
				{
					chave: '{{MS}}',
					valor: 'meses',
				},
				{
					chave: '{{AS}}',
					valor: 'anos',
				},
				{
					chave: '{{CS}}',
					valor: 'ciclos',
				},
			]

			for (var i = 0, len = conversao.length; i < len; i++) {
				texto = texto.replace(
					conversao[i].chave,
					this._traducao('conversao', conversao[i].valor)
				)
			}

			return texto
		},
		
		listaParametros() {
			return new Promise((resolve) => {
				this._providerParametro((lista) => {
					resolve(lista)
				})
			})
		},

		_getParametro(id) {
			return new Promise(async (resolve, reject) => {
				const parametros = await this.listaParametros()
				const parametro = parametros.find((item) => item.id == id)
				if (typeof parametro === 'object') {
					if (parametro.tipo_parametro == 'L') {
						resolve(parametro.value || '')
					} else {
						resolve(parametro.valor || '')
					}
				} else {
					reject('')
				}
			})
		},

		_getPrivilegio(id) {
			return $sessao.getPrivilegio(id)
		},

		_exibeModal(nome, width) {
			bus.$emit('modal-show', {
				name: nome,
				width: width,
			})
		},

		_escondeModal(nome) {
			bus.$emit('modal-hide', {
				name: nome,
			})
		},

		_print(time) {
			if (_.isNil(time)) {
				window.print()
			} else {
				setTimeout(function () {
					window.print()
				}, time)
			}
		},

		_exibeSub(sub) {
			bus.$emit('exibe-sub', sub)
		},

		_modalExcluir(callback, obj, texto, textoBotao, justificativa = false) {
			bus.$emit('cp-carrega-modal-excluir', texto, textoBotao, obj, justificativa)

			bus.$on('cp-modal-excluir-fechou', function () {
				callback({
					excluir: false,
					obj: obj,
				})
				bus.$off('cp-modal-excluir-fechou')
				bus.$off('cp-modal-excluir-excluir')
			})

			bus.$on('cp-modal-excluir-excluir', function (updatedObj) {
				callback({
					excluir: true,
					obj: updatedObj,
				})
				bus.$off('cp-modal-excluir-excluir')
				bus.$off('cp-modal-excluir-fechou')
			})
		},
		_modalReativar(callback, obj, texto, textoBotao) {
			bus.$emit('cp-carrega-modal-reativar', texto, textoBotao)

			bus.$on('cp-modal-reativar-fechou', function () {
				callback({
					reativar: false,
					obj: obj,
				})
				bus.$off('cp-modal-reativar-fechou')
				bus.$off('cp-modal-reativar-reativar')
			})

			bus.$on('cp-modal-reativar-reativar', function () {
				callback({
					reativar: true,
					obj: obj,
				})
				bus.$off('cp-modal-reativar-reativar')
				bus.$off('cp-modal-reativar-fechou')
			})
		},
		_modalDesativar(callback, obj, texto, textoBotao) {
			bus.$emit('cp-carrega-modal-desativar', texto, textoBotao)

			bus.$on('cp-modal-desativar-fechou', function () {
				callback({
					desativar: false,
					obj: obj,
				})
				bus.$off('cp-modal-desativar-fechou')
				bus.$off('cp-modal-desativar-desativar')
			})

			bus.$on('cp-modal-desativar-desativar', function () {
				callback({
					desativar: true,
					obj: obj,
				})
				bus.$off('cp-modal-desativar-desativar')
				bus.$off('cp-modal-desativar-fechou')
			})
		},
		_modalConfirmar(callback, obj, texto, textoBotao) {
			bus.$emit('cp-carrega-modal-confirmar', texto, textoBotao)

			bus.$on('cp-modal-confirmar-fechou', function () {
				callback({
					confirmar: false,
					obj: obj,
				})
				bus.$off('cp-modal-confirmar-fechou')
				bus.$off('cp-modal-confirmar-confirmar')
			})

			bus.$on('cp-modal-confirmar-confirmar', function () {
				callback({
					confirmar: true,
					obj: obj,
				})
				bus.$off('cp-modal-confirmar-confirmar')
				bus.$off('cp-modal-confirmar-fechou')
			})
		},

		_trataRetornoVazio(item) {
			if (_.isNil(item) || item == null || item == '') {
				return ''
			} else {
				return item
			}
		},
		_exportarExcel(id) {
			const dataAtual = moment().format($sessao.getDateFormat() + ' HH:mm:ss')
			// metodo de excluir
			const tableHtml = this.excluirColunasParaExcel(
				document.getElementById(id).cloneNode(true)
			).outerHTML
			const blobData = new Blob(['\ufeff' + tableHtml], {
				type: 'application/vnd.ms-excel',
			})
			const url = window.URL.createObjectURL(blobData)
			const a = document.createElement('a')
			a.href = url
			a.download = `${id}_${dataAtual}`
			a.click()
		},

		excluirColunasParaExcel(tableNode) {
			tableNode
				.querySelectorAll('.no-export')
				.forEach((column) => column.remove())
			return tableNode
		},

		_isset(valor) {
			if (valor !== null && valor !== undefined){
				return true
			}
			return false
		},

		_limpaObjeto(objetoLimpar) {
			Object.keys(objetoLimpar).forEach((chaveObjeto) => {
				objetoLimpar[chaveObjeto] = ''
			})
		},

		_doubleScroll(element) {
			var scrollbar = document.createElement('div')
			scrollbar.appendChild(document.createElement('div'))
			scrollbar.style.overflow = 'auto'
			scrollbar.style.overflowY = 'hidden'
			scrollbar.firstChild.style.width = element.scrollWidth + 'px'
			scrollbar.style.paddingTop = '1px'
			scrollbar.style.position = 'fixed'
			scrollbar.style.bottom = '10px'
			scrollbar.style['max-width'] = element.offsetWidth + 'px'
			scrollbar.firstChild.appendChild(document.createTextNode('\xA0'))
			var running = false
			scrollbar.onscroll = function () {
				if (running) {
					running = false
					return
				}
				running = true
				element.scrollLeft = scrollbar.scrollLeft
			}
			element.onscroll = function () {
				if (running) {
					running = false
					return
				}
				running = true
				scrollbar.scrollLeft = element.scrollLeft
			}
			element.parentNode.insertBefore(scrollbar, element)
		},

		_validaCPF(cpf) {
			cpf = cpf.replace(/\D+/g, '');
			if (cpf.length != 11) return false;
			if (cpf === 'undefined') return false;
			if (cpf[0].repeat(11) === cpf) return false;

			let cpfParcial = cpf.slice(0, -2);
			let digito1 = this.criaDigitoCPF(cpfParcial);
			let digito2 = this.criaDigitoCPF(cpfParcial + digito1);

			return cpfParcial + digito1 + digito2 === cpf;
		},

		criaDigitoCPF(cpfParcial) {
			let arrayCpf = Array.from(cpfParcial);
			let regressivo = cpfParcial.length + 1;
			let total = arrayCpf.reduce((acumulador, atual) => {
				acumulador += (regressivo * Number(atual));
				regressivo--;
				return acumulador;
			}, 0);

			const digito = 11 - (total % 11);
			return digito > 9 ? '0' : String(digito);;
		},

		_validaCNPJ(cnpj) {
			cnpj = cnpj.replace(/\D+/g, '');
			if (cnpj.length != 14) return false;
			if (cnpj === 'undefined') return false;

			const cnpjParcial = cnpj.slice(0, -2);
			const digito1 = this.criaDigitoCNPJ(cnpjParcial);
			const digito2 = this.criaDigitoCNPJ(cnpjParcial + digito1);

			const novoCnpj = cnpjParcial + digito1 + digito2;

			return novoCnpj === cnpj;
		},

		criaDigitoCNPJ(cnpjParcial) {
			let arrayInicio = [5, 4, 3, 2]
			let arrayFim = [9, 8, 7, 6, 5, 4, 3, 2];

			if (cnpjParcial.length == 13) arrayInicio.unshift(6);

			let resultadoSoma = 0;

			let contador = arrayInicio.length;

			for (let i = 0; i < contador; i++) {
				let arrayCalc = arrayInicio;

				if (contador <= arrayInicio.length) {
					resultadoSoma += Number(cnpjParcial[i]) * arrayCalc[i];
				}
				else {
					arrayCalc = arrayInicio.concat(arrayFim);
					resultadoSoma += Number(cnpjParcial[i] * arrayCalc[i]);
				}
				if ((i === arrayInicio.length - 1) && contador == arrayInicio.length) {
					contador = arrayInicio.length + arrayFim.length;
				}
			}

			return this.verificaDigitoCNPJ(resultadoSoma);
		},

		verificaDigitoCNPJ(resultadoSoma) {
			let resto = Math.floor(resultadoSoma / 11);
			let digito = resultadoSoma - (11 * resto);
			if (digito == 0 || digito == 1) {
				return '0';
			}
			else if (digito => 2 && digito <= 10) {
				return String(11 - digito);
			}
		},

		_validaForm(formulario, formErro, conditionMessages) {
			let passou = true
			for (const key in formulario) {
				const value = formulario[key]
				this.$set(formErro, key, '')
				const condicoes = conditionMessages.filter(
					(cm) => cm.property === key
				)
				if (condicoes.length > 0) {
					const mensagensErro = []
					for (const {condition, message} of condicoes) {
						if (condition(value)) {
							mensagensErro.push(message)
							passou = false
						}
					}
					if (mensagensErro.length > 0) {
						this.$set(formErro, key, mensagensErro)
					}
				}
			}
			if (!passou) {
				window.bus.$emit('exibir-notificacao', {
					text: 'Corrija os campos em vermelho.',
					type: 'danger'
				})
			}
			return passou
		},

		hexToRgb(hex) {
			var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
			return result
				? {
					r: parseInt(result[1], 16),
					g: parseInt(result[2], 16),
					b: parseInt(result[3], 16)
				  }
				: null
		},
		
		_getTextColor(hex) {
			if (!hex) {
				return 'black'
			}
			
			let {r, g, b} = this.hexToRgb(hex)
			if (r * 0.299 + g * 0.587 + b * 0.114 > 186) {
				return 'black'
			} else {
				return 'white'
			}
		},
	}
}
